// src/regl/ReglAttribute.ts
var ReglAttribute = class {
  constructor(gl, options) {
    const { buffer, offset, stride, normalized, size, divisor } = options;
    this.buffer = buffer;
    this.attribute = {
      buffer: buffer.get(),
      offset: offset || 0,
      stride: stride || 0,
      normalized: normalized || false,
      divisor: divisor || 0
    };
    if (size) {
      this.attribute.size = size;
    }
  }
  get() {
    return this.attribute;
  }
  updateBuffer(options) {
    this.buffer.subData(options);
  }
  destroy() {
    this.buffer.destroy();
  }
};
export {
  ReglAttribute as default
};
